import PaystubTemplate1 from './PaystubTemplate1'

export default PaystubTemplate1
